export const CAPTURE_WORKER = 'Chromatic capture';

export const UserAgent = Object.freeze({
  CAPTURE_WORKER,
});
